import React, { useState } from "react";
import { CheckCircle2, FileLock2, HardDrive, Loader2, Lock, Upload } from "lucide-react";
import ActiveCardShell from "../ActiveCardShell";
import { sleep, RunButton } from "./shared";

const DOCS = ["Driver's licence · owner", "Voided cheque", "Bank statements · last 3 months", "Articles of incorporation"];

export default function DocVaultCard({ merchant }) {
  const [state, setState] = useState({}); // i -> "in" | "synced"
  const [running, setRunning] = useState(false);

  const run = async () => {
    setRunning(true);
    setState({});
    for (let i = 0; i < DOCS.length; i += 1) {
      await sleep(550);
      setState((s) => ({ ...s, [i]: "in" }));
      await sleep(300);
      setState((s) => ({ ...s, [i]: "synced" }));
    }
    setRunning(false);
  };

  return (
    <ActiveCardShell id="T2220cr" kicker="ONBOARDING" title="Document Vault" Icon={FileLock2}
      actions={<RunButton tid="veroogle-t2220-run" running={running} onClick={run} Icon={running ? Loader2 : Upload} label="Collect documents" />}>
      <div className="font-mono text-[10px] tracking-[0.18em] uppercase text-slate-400 mb-3">Vault · {merchant.name}</div>
      <ul className="space-y-2">
        {DOCS.map((d, i) => {
          const st = state[i];
          return (
            <li key={d} data-testid={`veroogle-t2220-doc-${i}`}
              className={`flex items-center gap-3 rounded-lg border px-3 py-2.5 transition-all duration-300 ${st ? "border-emerald-500/30 bg-emerald-500/5 opacity-100 translate-x-0" : "border-white/10 bg-navy-950/40 opacity-50"}`}>
              <FileLock2 className={`w-4 h-4 ${st ? "text-emerald-300" : "text-slate-600"}`} />
              <span className={`text-sm flex-1 truncate ${st ? "text-white" : "text-slate-500"}`}>{d}</span>
              {st && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded border border-brand-cyan/30 text-brand-cyan font-mono text-[9px] tracking-[0.14em] uppercase">
                  <Lock className="w-3 h-3" /> Encrypted
                </span>
              )}
              {st === "synced" && (
                <span className="inline-flex items-center gap-1 text-emerald-300 font-mono text-[9px] tracking-[0.14em] uppercase" data-testid={`veroogle-t2220-synced-${i}`}>
                  <HardDrive className="w-3 h-3" /> Drive <CheckCircle2 className="w-3 h-3" />
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </ActiveCardShell>
  );
}
